import get from 'lodash/get';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import {createEventHandler} from 'recompose';
import fuse from '../../../../_libs/redux-fusion/index';
import {createAssetRequestModal} from '../../../../assets/redux/createAsset';
import {getId} from '../../../../core-utilities/domain/ReduxUtils';
import {persistEvent} from '../../../../core-utilities/react-utils';
import {ReduxListStreamedContainer} from '../../../../core-utilities/redux/ReduxListContainer';
import {assetsStates} from '../../../../assets/router-config';
import {selectedAsset} from '../../../model/actions';
import {getOrganization} from '../../../model/reducers/state';
import {componentOptions, reduxList} from '../../redux/assets';
import {navStates} from '../../../router';
import {buildOrganizationNavigationOptions} from '../../utils/itemActions';
import {AppNavigationAssetsView} from './AppNavigationAssetsView';
import {stateGoBack, stateGoEnter} from '../../../actions';


const StreamedComponent = (state$, dispatch) => (props$) => {
  const {
    onItemShowOptions: onShowOrgOptions,
  } = buildOrganizationNavigationOptions({
    dispatch,
    selectFirst: false,
  });
  const selectThenNav = (asset, navAction) => {
    dispatch(selectedAsset(getId(asset)));
    dispatch(navAction);
  };
  const onClickBack = () => dispatch(stateGoBack({state: navStates.orgsList}));
  const onClickCreateAsset = () => dispatch(createAssetRequestModal.actions.showModal());
  const onNavToOverview = (e, asset) => selectThenNav(asset, stateGoEnter({state: assetsStates.assetsHome}));
  const {
    handler: onClickOptions,
    stream: clickOptions$,
  } = createEventHandler();

  const organization$ = state$
    .map(getOrganization)
    .distinctUntilChanged();

  clickOptions$
    .do(persistEvent)
    .withLatestFrom(organization$)
    .debounceTime(300)
    .takeUntil(props$.last())
    .subscribe(([ev, organization]) => {
      onShowOrgOptions(ev, organization);
    });

  return props$
    .combineLatest(
      organization$,
      (props, organization) => ({
        ...props,
        organizationName: get(organization, 'name'),
        init: !!getId(organization),
        parentId: getId(organization),
        onClickBack,
        onClickOptions,
        onClickCreateAsset,
        onNavToOverview,
      }));
};

// The fuse container must inject the parentId into the ReduxListStreamedContainer
export const ListComponent = ReduxListStreamedContainer(AppNavigationAssetsView, reduxList, componentOptions);
export const AppNavigationAssetsContainer = fuse(StreamedComponent)(ListComponent);



// WEBPACK FOOTER //
// ./src/js/app/navigation/components/AppNavigationAssets/AppNavigationAssetsContainer.js